import React from 'react';
import Slider from 'react-slick';
import tw from 'tailwind-styled-components';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CarouselLoading } from './SkeletonLoading/CarouselLoading';

const Carousel = ({ carousels, isLoading }) => {
    const settings = {  // Slider settings
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
    };

    if (isLoading) {
        return <CarouselLoading />;
    }

    // Render nothing if the data isn't available yet or is empty.
    if (!carousels || carousels.length === 0) {
        return null;
    }

    return (
        <CarouselContainer>
            <Slider {...settings}>
                {carousels.map((carousel) => (
                    <Slide key={carousel.id}>
                        <CarouselImage
                            src={carousel.image_url}
                            alt={carousel.title || 'Carousel Image'}
                        />
                    </Slide>
                ))}
            </Slider>
        </CarouselContainer>
    );
};

// Styled Components
const CarouselContainer = tw.div`
  w-full mx-auto overflow-hidden
`;

// const Slide = tw.div`
//   outline-none focus:outline-none
//   md:h-96 h-64
// `;

const CarouselImage = tw.img`
  w-full h-full object-cover 
`;
const Slide = tw.div`
  outline-none focus:outline-none
  w-full relative
  max-h-[480px]
  aspect-video md:aspect-[16/7]
`;

export default Carousel;